import { render, staticRenderFns } from "./Performance.vue?vue&type=template&id=1880c8f4&scoped=true"
import script from "./Performance.vue?vue&type=script&lang=js"
export * from "./Performance.vue?vue&type=script&lang=js"
import style0 from "./Performance.vue?vue&type=style&index=0&id=1880c8f4&prod&scoped=true&lang=css"
import style1 from "./Performance.vue?vue&type=style&index=1&id=1880c8f4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1880c8f4",
  null
  
)

export default component.exports